module.exports = __webpack_public_path__ + "static/img/zhengshu.88a0bbc2.png";